// extracted by mini-css-extract-plugin
export default {"panel":"_2mHr","panelBody":"_1efc","title":"_1bcy"};